import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum CustomerProductEvent {
  BACK_IN_STOCK = "BACK_IN_STOCK",
  LOW_INVENTORY = "LOW_INVENTORY",
}

export const CustomerProductNotificationDbParser = z.object({
  _id: zExt.objectId(),
  customerEmail: z.string().optional(),
  customerPhone: z.string().optional(),
  teamId: zExt.objectId(),
  productId: z.string(),
  variantId: z.string(),
  subscribedEvent: createEnum(CustomerProductEvent),
  notificationSentAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type CustomerProductNotification = z.infer<
  typeof CustomerProductNotificationDbParser
>;

export const CustomerProductNotificationDbParserArray = z.array(
  CustomerProductNotificationDbParser,
);

export const BackInStockProductSchema = z.object({
  id: z.string(),
  productId: z.string(),
  variantId: z.string(),
  name: z.string(),
  sku: z.string(),
  imageUrl: z.string().optional(),
  waitingCount: z.number(),
  notifiedCount: z.number(),
  potentialRevenue: z.number(),
  status: createEnum(["in_stock", "out_of_stock"]),
  conversionRate: z.number(),
  openRate: z.number(),
  ctr: z.number(),
  avgWaitDays: z.number(),
  price: z.number(),
});

export type BackInStockProduct = z.infer<typeof BackInStockProductSchema>;

export const BackInStockSubscriberSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  subscribedDate: z.date(),
  status: createEnum(["waiting", "notified"]),
  notifiedDate: z.date().optional(),
  waitingDays: z.number().optional(),
});

export type BackInStockSubscriber = z.infer<typeof BackInStockSubscriberSchema>;
